class BptProductTabs extends HTMLElement {
  connectedCallback() {
    this.breakpoint = window.matchMedia(`(max-width: ${this.dataset.mobileBreakpoint || 749}px)`);
    this.triggers = [...this.querySelectorAll('[data-tab-trigger]')];
    this.panels = [...this.querySelectorAll('[data-tab-panel]')];

    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);
    this.addEventListener('shopify:block:select', this.handleBlockSelect);
    this.breakpoint.addEventListener('change', this.handleBreakpoint);
    this.syncLayout();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeydown);
    this.removeEventListener('shopify:block:select', this.handleBlockSelect);
    this.breakpoint?.removeEventListener('change', this.handleBreakpoint);
  }

  handleClick = (event) => {
    const trigger = event.target.closest('[data-tab-trigger]');
    if (!trigger || !this.contains(trigger)) return;

    const tabId = trigger.dataset.tabTrigger;
    if (this.breakpoint.matches && trigger.classList.contains('bpt-tabs__mobile-trigger')) {
      const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
      this.setMobilePanel(tabId, willOpen);
      return;
    }

    this.activateDesktopTab(tabId);
  };

  handleKeydown = (event) => {
    if (this.breakpoint.matches || !event.target.matches('[role="tab"]')) return;
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    const tabs = this.triggers.filter((trigger) => trigger.matches('[role="tab"]'));
    const currentIndex = tabs.indexOf(event.target);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;

    event.preventDefault();
    tabs[nextIndex].focus();
    this.activateDesktopTab(tabs[nextIndex].dataset.tabTrigger);
  };

  handleBreakpoint = () => this.syncLayout();

  handleBlockSelect = (event) => {
    const item = event.target.closest('.bpt-tabs__item');
    const panel = item?.querySelector('[data-tab-panel]');
    if (!panel) return;

    if (this.breakpoint.matches) this.setMobilePanel(panel.dataset.tabPanel, true);
    else this.activateDesktopTab(panel.dataset.tabPanel);
  };

  activateDesktopTab(tabId) {
    this.triggers.forEach((trigger) => {
      if (!trigger.matches('[role="tab"]')) return;
      const active = trigger.dataset.tabTrigger === tabId;
      trigger.classList.toggle('is-active', active);
      trigger.setAttribute('aria-selected', String(active));
      trigger.tabIndex = active ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.tabPanel !== tabId;
    });
  }

  setMobilePanel(tabId, open) {
    const trigger = this.querySelector(`.bpt-tabs__mobile-trigger[data-tab-trigger="${CSS.escape(tabId)}"]`);
    const panel = this.querySelector(`[data-tab-panel="${CSS.escape(tabId)}"]`);
    if (!trigger || !panel) return;

    trigger.classList.toggle('is-active', open);
    trigger.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
  }

  syncLayout() {
    if (this.breakpoint.matches) {
      this.panels.forEach((panel, index) => {
        const trigger = this.querySelector(`.bpt-tabs__mobile-trigger[data-tab-trigger="${CSS.escape(panel.dataset.tabPanel)}"]`);
        const open = index === 0;
        panel.hidden = !open;
        trigger?.classList.toggle('is-active', open);
        trigger?.setAttribute('aria-expanded', String(open));
      });
      return;
    }

    const activeTab = this.querySelector('[role="tab"].is-active') || this.querySelector('[role="tab"]');
    if (activeTab) this.activateDesktopTab(activeTab.dataset.tabTrigger);
  }
}

if (!customElements.get('bpt-product-tabs')) {
  customElements.define('bpt-product-tabs', BptProductTabs);
}
